<template>
	<div class="users-form-container">
		<!-- 页面头部 -->
		<div class="page-header">
			<div class="header-content">
				<div class="header-left">
					<div class="back-button" @click="back()">
						<i class="el-icon-arrow-left"></i>
					</div>
					<div class="header-info">
						<h1 class="page-title">
							{{ type === 'info' ? '账号详情' : (id ? '编辑账号' : '新增账号') }}
						</h1>
						<div class="breadcrumb">
							<span class="breadcrumb-item">后台账号管理</span>
							<i class="el-icon-arrow-right"></i>
							<span class="breadcrumb-current">
								{{ type === 'info' ? '查看详情' : (id ? '编辑账号' : '新增账号') }}
							</span>
						</div>
					</div>
				</div>
				<div class="header-actions" v-if="type !== 'info'">
					<el-button @click="back()" class="cancel-btn">
						<i class="el-icon-close"></i>
						取消
					</el-button>
					<el-button type="primary" @click="onSubmit" :loading="submitLoading" class="submit-btn">
						<i class="el-icon-check"></i>
						{{ submitLoading ? '保存中...' : '保存' }}
					</el-button>
				</div>
				<div class="header-actions" v-else>
					<el-button @click="back()" class="back-btn">
						<i class="el-icon-back"></i>
						返回
					</el-button>
				</div>
			</div>
		</div>

		<!-- 表单内容 -->
		<div class="form-content">
		<el-form
			ref="ruleForm"
			:model="ruleForm"
			:rules="rules"
				label-width="120px"
				class="users-form"
			>
				<!-- 基本信息 -->
				<div class="form-section">
					<h3 class="section-title">
						<svg class="section-icon" viewBox="0 0 24 24">
							<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
						</svg>
						基本信息
					</h3>
					
					<!-- 用户名 -->
					<el-form-item label="用户名" prop="username" class="form-item">
						<div class="input-wrapper">
							<div class="input-field" :class="{ 'readonly': type === 'info' || ro.username }">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.username" 
									placeholder="请输入用户名" 
									:readonly="type === 'info' || ro.username"
									clearable
									class="form-input"
									maxlength="20"
									show-word-limit
								></el-input>
								<div class="readonly-indicator" v-if="type === 'info' || ro.username">
									<svg class="lock-icon" viewBox="0 0 24 24">
										<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
									</svg>
								</div>
							</div>
							<span class="field-tip" v-if="type !== 'info'">用户名长度为3-20个字符，支持字母、数字、下划线</span>
						</div>
				</el-form-item>

					<!-- 密码 -->
					<el-form-item label="密码" prop="password" class="form-item">
						<div class="input-wrapper">
							<div class="input-field" :class="{ 'readonly': type === 'info' || ro.password }">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.password" 
									:type="showPassword ? 'text' : 'password'"
									placeholder="请输入密码" 
									:readonly="type === 'info' || ro.password"
									clearable
									class="form-input"
									maxlength="50"
									show-word-limit
								></el-input>
								<div class="field-actions" v-if="type !== 'info' && !ro.password">
									<button type="button" class="toggle-btn" @click="showPassword = !showPassword">
										<svg v-if="!showPassword" class="toggle-icon" viewBox="0 0 24 24">
											<path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"/>
										</svg>
										<svg v-else class="toggle-icon" viewBox="0 0 24 24">
											<path d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.09L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.76,7.13 11.37,7 12,7Z"/>
										</svg>
									</button>
								</div>
								<div class="readonly-indicator" v-if="type === 'info' || ro.password">
									<svg class="lock-icon" viewBox="0 0 24 24">
										<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
									</svg>
								</div>
							</div>
							<span class="field-tip" v-if="type !== 'info'">密码长度为6-50个字符，建议包含字母、数字和特殊字符</span>
						</div>
				</el-form-item>

					<!-- 角色 -->
					<el-form-item label="角色" prop="role" class="form-item">
						<div class="input-wrapper">
							
							
							<div class="role-selector" v-if="type !== 'info' && !ro.role">
								<div 
									v-for="(option, index) in availableRoleOptions" 
									:key="index"
									class="role-option"
									:class="{ 'active': ruleForm.role === option }"
									@click="selectRole(option)"
								>
									<div class="role-icon">
										<svg v-if="option === '管理员'" viewBox="0 0 24 24">
											<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
										</svg>
										<svg v-else viewBox="0 0 24 24">
											<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
										</svg>
									</div>
									<div class="role-info">
										<span class="role-name">{{ option }}</span>
										<span class="role-desc">{{ getRoleDescription(option) }}</span>
									</div>
								</div>
							</div>
							<div v-else class="readonly-display">
								<div class="readonly-role">
									<el-tag 
										:type="getRoleTagType(ruleForm.role)"
										class="role-tag"
									>
										<i :class="getRoleIcon(ruleForm.role)"></i>
										{{ ruleForm.role || '未设置' }}
									</el-tag>
								</div>
							</div>
							<span class="field-tip" v-if="type !== 'info'">
								{{ isNewUser ? '新增用户默认为操作员角色' : '请选择账号的角色权限' }}
							</span>
						</div>
				</el-form-item>

					<!-- 状态 -->
					<el-form-item label="账号状态" prop="status" class="form-item">
						<div class="input-wrapper">
							<div class="status-selector" v-if="type !== 'info' && !ro.status">
								<div 
									v-for="(option, index) in statusOptions" 
									:key="index"
									class="status-option"
									:class="{ 'active': ruleForm.status === option }"
									@click="selectStatus(option)"
								>
									<div class="status-icon">
										<svg v-if="option === '启用'" viewBox="0 0 24 24">
											<path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"/>
										</svg>
										<svg v-else viewBox="0 0 24 24">
											<path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
										</svg>
									</div>
									<div class="status-info">
										<span class="status-name">{{ option }}</span>
										<span class="status-desc">{{ getStatusDescription(option) }}</span>
									</div>
								</div>
							</div>
							<div v-else class="readonly-display">
								<div class="readonly-status">
									<el-tag 
										:type="getStatusTagType(ruleForm.status)"
										class="status-tag"
									>
										<i :class="getStatusIcon(ruleForm.status)"></i>
										{{ ruleForm.status || '启用' }}
									</el-tag>
								</div>
							</div>
							<span class="field-tip" v-if="type !== 'info'">
								选择账号的启用状态，禁用后账号将无法登录
							</span>
						</div>
				</el-form-item>
				</div>

				<!-- 提交按钮 (移动端显示) -->
				<div class="mobile-actions" v-if="type !== 'info'">
					<el-button @click="back()" class="mobile-cancel-btn">
						<i class="el-icon-close"></i>
						取消
					</el-button>
					<el-button type="primary" @click="onSubmit" :loading="submitLoading" class="mobile-submit-btn">
						<i class="el-icon-check"></i>
						{{ submitLoading ? '保存中...' : '保存' }}
					</el-button>
				</div>
				<div class="mobile-actions" v-else>
					<el-button @click="back()" class="mobile-back-btn">
						<i class="el-icon-back"></i>
						返回
					</el-button>
				</div>
			</el-form>
		</div>
  </div>
</template>

<script>
// 数字，邮件，手机，url，身份证校验
import { isNumber,isIntNumer,isEmail,isPhone, isMobile,isURL,checkIdCard } from "@/utils/validate";
export default {
	data() {
		let self = this
		var validateUsername = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入用户名'));
			} else if (value.length < 3 || value.length > 20) {
				callback(new Error('用户名长度为3-20个字符'));
			} else if (!/^[a-zA-Z0-9_]+$/.test(value)) {
				callback(new Error('用户名只能包含字母、数字和下划线'));
			} else {
				callback();
			}
		};
		var validatePassword = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入密码'));
			} else if (value.length < 6 || value.length > 50) {
				callback(new Error('密码长度为6-50个字符'));
			} else {
				callback();
			}
		};
		return {
			id: '',
			type: '',
			submitLoading: false,
			showPassword: false,
			
			ro:{
				username : false,
				password : false,
				role : false,
				status : false,
			},
			
			ruleForm: {
				username: '',
				password: '',
				role: '操作员',  // 默认设置为操作员
				status: '启用', // 默认设置为启用
			},
			
			rules: {
				username: [
					{ validator: validateUsername, trigger: 'blur' },
				],
				password: [
					{ validator: validatePassword, trigger: 'blur' },
				],
				role: [
					{ required: true, message: '请选择角色', trigger: 'change' },
				],
				status: [
					{ required: true, message: '请选择状态', trigger: 'change' },
				],
			},

			roleOptions: ['管理员', '操作员'],
			statusOptions: ['启用', '禁用']
		};
	},
	props: ["parent"],
	computed: {
		isNewUser() {
			return !this.id;
		},
		
		availableRoleOptions() {
			// 新增用户时只能选择操作员角色
			if (this.isNewUser) {
				return ['操作员'];
			}
			// 编辑用户时可以选择所有角色
			return this.roleOptions;
		}
	},
	created() {
	},
	methods: {
		
		// 下载
		download(file){
			window.open(`${file}`)
		},

		// 获取角色描述
		getRoleDescription(role) {
			const descriptions = {
				'管理员': '拥有系统所有权限',
				'操作员': '普通操作员，基本功能权限'
			};
			return descriptions[role] || '';
		},

		// 获取角色标签类型
		getRoleTagType(role) {
			if (role === '管理员') return 'danger';
			if (role === '操作员') return 'success';
			return 'info';
		},

		// 获取角色图标
		getRoleIcon(role) {
			if (role === '管理员') return 'el-icon-user-solid';
			if (role === '操作员') return 'el-icon-user';
			return 'el-icon-question';
		},

		// 选择角色
		selectRole(role) {
			if (this.type !== 'info' && !this.ro.role) {
				// 新增用户时，如果尝试选择管理员角色，给出提示并保持操作员角色
				if (this.isNewUser && role === '管理员') {
					this.$message.warning('新增用户时只能选择操作员角色，管理员权限需要在创建后单独分配');
					this.ruleForm.role = '操作员';
					return;
				}
				this.ruleForm.role = role;
			}
		},

		// 获取状态描述
		getStatusDescription(status) {
			const descriptions = {
				'启用': '账号正常，可以登录系统',
				'禁用': '账号已禁用，无法登录系统'
			};
			return descriptions[status] || '';
		},

		// 获取状态标签类型
		getStatusTagType(status) {
			if (status === '禁用') return 'danger';
			if (status === '启用') return 'success';
			return 'info';
		},

		// 获取状态图标
		getStatusIcon(status) {
			if (status === '禁用') return 'el-icon-close';
			if (status === '启用') return 'el-icon-check';
			return 'el-icon-question';
		},

		// 选择状态
		selectStatus(status) {
			if (this.type !== 'info' && !this.ro.status) {
				this.ruleForm.status = status;
			}
		},

		// 初始化
		init(id,type) {
			if (id) {
				this.id = id;
				this.type = type;
			}
			
			// 如果是新增用户，设置默认角色为操作员
			if (!id) {
				this.ruleForm.role = '操作员';
				this.ruleForm.status = '启用'; // 新增用户默认启用
			}
			
			if(this.type=='info'||this.type=='else'){
				this.info(id);
			}else if(this.type=='logistics'){
				this.logistics=false;
				this.info(id);
			}else if(this.type=='cross'){
				var obj = this.$storage.getObj('crossObj');
				for (var o in obj){
						if(o=='username'){
							this.ruleForm.username = obj[o];
							this.ro.username = true;
							continue;
						}
						if(o=='password'){
							this.ruleForm.password = obj[o];
							this.ro.password = true;
							continue;
						}
						if(o=='role'){
							this.ruleForm.role = obj[o];
							this.ro.role = true;
							continue;
						}
						if(o=='status'){
							this.ruleForm.status = obj[o];
							this.ro.status = true;
							continue;
				}
			}
			}
		},

    info(id) {
      this.$http({
        url: `users/info/${id}`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
        this.ruleForm = data.data;
					// 如果角色为空，设置默认值为操作员
					if (!this.ruleForm.role) {
						this.ruleForm.role = '操作员';
					}
					if (!this.ruleForm.status) {
						this.ruleForm.status = '启用';
					}
        } else {
          this.$message.error(data.msg);
        }
      });
    },

    // 提交
    onSubmit() {
			this.submitLoading = true;

var objcross = this.$storage.getObj('crossObj');

      //更新跨表属性
       var crossuserid;
       var crossrefid;
       var crossoptnum;
       if(this.type=='cross'){
                var statusColumnName = this.$storage.get('statusColumnName');
                var statusColumnValue = this.$storage.get('statusColumnValue');
                if(statusColumnName!='') {
                        var obj = this.$storage.getObj('crossObj');
                       if(statusColumnName && !statusColumnName.startsWith("[")) {
                               for (var o in obj){
                                 if(o==statusColumnName){
                                   obj[o] = statusColumnValue;
                                 }
                               }
                               var table = this.$storage.get('crossTable');
                             this.$http({
                                 url: `${table}/update`,
                                 method: "post",
                                 data: obj
                               }).then(({ data }) => {});
                       } else {
                               crossuserid=this.$storage.get('userid');
                               crossrefid=obj['id'];
                               crossoptnum=this.$storage.get('statusColumnName');
                               crossoptnum=crossoptnum.replace(/\[/,"").replace(/\]/,"");
                        }
                }
        }
       this.$refs["ruleForm"].validate(valid => {
         if (valid) {
		 if(crossrefid && crossuserid) {
			 this.ruleForm.crossuserid = crossuserid;
			 this.ruleForm.crossrefid = crossrefid;
			let params = { 
				page: 1, 
				limit: 10, 
				crossuserid:this.ruleForm.crossuserid,
				crossrefid:this.ruleForm.crossrefid,
			} 
			this.$http({ 
				url: "users/page", 
				method: "get", 
				params: params 
			}).then(({ 
				data 
			}) => { 
				if (data && data.code === 0) { 
				       if(data.data.total>=crossoptnum) {
					     this.$message.error(this.$storage.get('tips'));
									 this.submitLoading = false;
					       return false;
				       } else {
								 this.saveUser();
							       }
					   } else {
								this.submitLoading = false;
					   }
					 });
					} else {
						this.saveUser();
				       }
				} else { 
					this.submitLoading = false;
				} 
			});
		},

		// 保存用户
		saveUser() {
			 this.$http({
			   url: `users/${!this.ruleForm.id ? "save" : "update"}`,
			   method: "post",
			   data: this.ruleForm
			 }).then(({ data }) => {
				this.submitLoading = false;
			   if (data && data.code === 0) {
			     this.$message({
			       message: "操作成功",
			       type: "success",
			       duration: 1500,
			       onClose: () => {
				 this.parent.showFlag = true;
				 this.parent.addOrUpdateFlag = false;
				 this.parent.usersCrossAddOrUpdateFlag = false;
				 this.parent.search();
				 this.parent.contentStyleChange();
			       }
			     });
			   } else {
			     this.$message.error(data.msg);
			   }
			}).catch(() => {
				this.submitLoading = false;
       });
    },

    // 获取uuid
    getUUID () {
      return new Date().getTime();
    },
    // 返回
    back() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.usersCrossAddOrUpdateFlag = false;
      this.parent.contentStyleChange();
    },
  }
};
</script>
<style lang="scss" scoped>
.users-form-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: white;
		padding: 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-left {
			display: flex;
			align-items: center;
			gap: 16px;

			.back-button {
				width: 40px;
				height: 40px;
				background: #f3f4f6;
				border-radius: 8px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				transition: all 0.2s ease;

				&:hover {
					background: #e5e7eb;
					transform: translateX(-2px);
				}

				i {
					font-size: 18px;
					color: #374151;
				}
			}

			.header-info {
				.page-title {
					font-size: 24px;
	  	  font-weight: 600;
					color: #1e293b;
					margin: 0 0 4px 0;
				}

				.breadcrumb {
					display: flex;
					align-items: center;
					gap: 8px;
					color: #64748b;
	  	  font-size: 14px;

					.breadcrumb-item {
						color: #6b7280;
					}

					i {
						font-size: 12px;
						color: #9ca3af;
					}

					.breadcrumb-current {
						color: #3b82f6;
						font-weight: 500;
					}
				}
			}
		}

		.header-actions {
			display: flex;
			gap: 12px;

			.el-button {
				padding: 10px 20px;
				font-weight: 500;
				border-radius: 6px;
				transition: all 0.2s ease;

				&.cancel-btn {
					color: #6b7280;
					border-color: #d1d5db;

					&:hover {
						color: #374151;
						border-color: #9ca3af;
					}
				}

				&.submit-btn {
					background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
					border: none;

					&:hover {
						transform: translateY(-1px);
						box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
					}
				}

				&.back-btn {
					background: #10b981;
					border-color: #10b981;

					&:hover {
						background: #059669;
						border-color: #059669;
					}
				}
			}
		}
	}
}

// 表单内容
.form-content {
	.users-form {
		background: white;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		overflow: hidden;

		.form-section {
			padding: 32px;

			.section-title {
				display: flex;
				align-items: center;
				gap: 12px;
				font-size: 18px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 32px 0;
				padding-bottom: 16px;
				border-bottom: 2px solid #f1f5f9;

				.section-icon {
					width: 20px;
					height: 20px;
					fill: #3b82f6;
				}
			}

			.form-item {
				margin-bottom: 32px;

				&:last-child {
					margin-bottom: 0;
				}

				:deep(.el-form-item__label) {
					font-weight: 600;
					color: #374151;
					line-height: 24px;
					padding-bottom: 8px;
				}

				:deep(.el-form-item__content) {
					line-height: 24px;
				}

				.input-wrapper {
					.input-field {
						position: relative;
						display: flex;
						align-items: center;
						background: #f9fafb;
						border: 2px solid #e5e7eb;
						border-radius: 8px;
						padding: 12px 16px;
						transition: all 0.2s ease;

						&:hover {
							border-color: #d1d5db;
						}

						&:focus-within {
							border-color: #3b82f6;
							background: white;
							box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
						}

						&.readonly {
							background: #f3f4f6;
							border-color: #d1d5db;
						}

						.field-icon {
							width: 20px;
							height: 20px;
							fill: #6b7280;
							margin-right: 12px;
							flex-shrink: 0;
						}

						.form-input {
							flex: 1;
							border: none;
							background: transparent;

							:deep(.el-input__inner) {
								border: none;
								background: transparent;
								padding: 0;
	  	  font-size: 14px;
								color: #374151;

								&::placeholder {
									color: #9ca3af;
								}

								&:focus {
									box-shadow: none;
								}
							}

							:deep(.el-input__count) {
		background: transparent;
								color: #9ca3af;
								font-size: 12px;
							}
						}

						.field-actions {
							margin-left: 12px;

							.toggle-btn {
								background: transparent;
								border: none;
								padding: 4px;
	  	  cursor: pointer;
								border-radius: 4px;
								transition: background 0.2s ease;

								&:hover {
									background: #f3f4f6;
								}

								.toggle-icon {
									width: 16px;
									height: 16px;
									fill: #6b7280;
								}
							}
						}

						.readonly-indicator {
							margin-left: 12px;

							.lock-icon {
								width: 16px;
								height: 16px;
								fill: #9ca3af;
							}
						}
					}

					.field-tip {
						display: block;
						margin-top: 8px;
						font-size: 13px;
						color: #6b7280;
						line-height: 1.4;
					}

					// 角色限制提示
					.role-notice {
						margin-bottom: 16px;
						padding: 12px 16px;
						background: #fef3c7;
						border: 1px solid #f59e0b;
	  	  border-radius: 6px;

						.notice-content {
							display: flex;
							align-items: center;
							gap: 8px;

							i {
								color: #f59e0b;
								font-size: 16px;
								flex-shrink: 0;
							}

							span {
								color: #92400e;
								font-size: 13px;
								line-height: 1.4;
							}
						}
					}

					// 角色选择器
					.role-selector {
						display: flex;
						flex-direction: column;
						gap: 12px;

						.role-option {
							display: flex;
							align-items: center;
							gap: 16px;
							padding: 16px;
							background: #f9fafb;
							border: 2px solid #e5e7eb;
							border-radius: 8px;
	  	  cursor: pointer;
							transition: all 0.2s ease;

							&:hover {
								border-color: #d1d5db;
								background: #f3f4f6;
							}

							&.active {
								border-color: #3b82f6;
								background: #eff6ff;
								box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);

								.role-icon svg {
									fill: #3b82f6;
								}

								.role-name {
									color: #1d4ed8;
									font-weight: 600;
								}
							}

							.role-icon {
								width: 48px;
								height: 48px;
								background: white;
								border-radius: 50%;
								display: flex;
								align-items: center;
								justify-content: center;
								box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

								svg {
									width: 24px;
									height: 24px;
									fill: #6b7280;
									transition: fill 0.2s ease;
								}
							}

							.role-info {
								flex: 1;

								.role-name {
									display: block;
									font-size: 16px;
									font-weight: 500;
									color: #374151;
									margin-bottom: 4px;
									transition: all 0.2s ease;
								}

								.role-desc {
									font-size: 13px;
									color: #6b7280;
									line-height: 1.4;
								}
							}
						}
					}

					// 状态选择器
					.status-selector {
						display: flex;
						flex-direction: column;
						gap: 12px;

						.status-option {
							display: flex;
							align-items: center;
							gap: 16px;
							padding: 16px;
							background: #f9fafb;
							border: 2px solid #e5e7eb;
							border-radius: 8px;
	  	  cursor: pointer;
							transition: all 0.2s ease;

							&:hover {
								border-color: #d1d5db;
								background: #f3f4f6;
							}

							&.active {
								border-color: #3b82f6;
								background: #eff6ff;
								box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);

								.status-icon svg {
									fill: #3b82f6;
								}

								.status-name {
									color: #1d4ed8;
									font-weight: 600;
								}
							}

							.status-icon {
								width: 48px;
								height: 48px;
								background: white;
								border-radius: 50%;
								display: flex;
								align-items: center;
								justify-content: center;
								box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

								svg {
									width: 24px;
									height: 24px;
									fill: #6b7280;
									transition: fill 0.2s ease;
								}
							}

							.status-info {
								flex: 1;

								.status-name {
									display: block;
									font-size: 16px;
									font-weight: 500;
									color: #374151;
									margin-bottom: 4px;
									transition: all 0.2s ease;
								}

								.status-desc {
									font-size: 13px;
									color: #6b7280;
									line-height: 1.4;
								}
							}
						}
					}

					.readonly-display {
						.readonly-role {
							.role-tag {
								i {
									margin-right: 4px;
								}
							}
						}
						.readonly-status {
							.status-tag {
								i {
									margin-right: 4px;
								}
							}
						}
					}
				}
			}
		}

		// 移动端操作按钮
		.mobile-actions {
			display: none;
			padding: 24px 32px;
			border-top: 1px solid #f1f5f9;
			gap: 12px;

			.el-button {
				flex: 1;
				padding: 12px 24px;
				font-weight: 500;
	  	  border-radius: 6px;

				&.mobile-cancel-btn {
					color: #6b7280;
					border-color: #d1d5db;
				}

				&.mobile-submit-btn {
					background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
					border: none;
				}

				&.mobile-back-btn {
					background: #10b981;
					border-color: #10b981;
				}
			}
		}
	}
}

// 响应式设计
@media (max-width: 1024px) {
	.users-form-container {
		padding: 20px;
	}

	.page-header {
		.header-content {
			.header-actions {
				display: none;
			}
		}
	}

	.form-content {
		.users-form {
			.mobile-actions {
				display: flex;
			}
		}
	}
}

@media (max-width: 768px) {
	.users-form-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			gap: 16px;
			align-items: flex-start;

			.header-left {
				width: 100%;

				.header-info {
					.page-title {
						font-size: 20px;
					}

					.breadcrumb {
						flex-wrap: wrap;
					}
				}
			}
		}
	}

	.form-content {
		.users-form {
			.form-section {
				padding: 24px 20px;

				.section-title {
					font-size: 16px;
					margin-bottom: 24px;
				}

				.form-item {
					margin-bottom: 24px;

					.input-wrapper {
						.input-field {
							padding: 10px 12px;

							.field-icon {
								width: 18px;
								height: 18px;
								margin-right: 10px;
							}
						}

						.role-selector {
							.role-option {
	  	  padding: 12px;

								.role-icon {
									width: 40px;
									height: 40px;

									svg {
										width: 20px;
										height: 20px;
									}
								}

								.role-info {
									.role-name {
										font-size: 15px;
									}

									.role-desc {
										font-size: 12px;
									}
								}
							}
						}
						.status-selector {
							.status-option {
								padding: 12px;

								.status-icon {
									width: 40px;
									height: 40px;

									svg {
										width: 20px;
										height: 20px;
									}
								}

								.status-info {
									.status-name {
										font-size: 15px;
									}

									.status-desc {
										font-size: 12px;
									}
								}
							}
						}
					}
				}
			}

			.mobile-actions {
				padding: 20px;
			}
		}
	}
}

@media (max-width: 480px) {
	.users-form-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			padding: 16px;

			.header-left {
				.back-button {
					width: 36px;
					height: 36px;

					i {
						font-size: 16px;
					}
				}

				.header-info {
					.page-title {
						font-size: 18px;
					}

					.breadcrumb {
						font-size: 13px;
					}
				}
			}
		}
	}

	.form-content {
		.users-form {
			.form-section {
				padding: 20px 16px;

				.form-item {
					:deep(.el-form-item__label) {
	  	  font-size: 14px;
					}

					.input-wrapper {
						.input-field {
							padding: 8px 10px;

							.form-input {
								:deep(.el-input__inner) {
									font-size: 13px;
								}
							}
						}

						.field-tip {
							font-size: 12px;
						}

						.role-selector {
							.role-option {
								padding: 10px;
								gap: 12px;

								.role-icon {
									width: 36px;
									height: 36px;

									svg {
										width: 18px;
										height: 18px;
									}
								}

								.role-info {
									.role-name {
										font-size: 14px;
									}

									.role-desc {
										font-size: 11px;
									}
								}
							}
						}
						.status-selector {
							.status-option {
								padding: 10px;
								gap: 12px;

								.status-icon {
									width: 36px;
									height: 36px;

									svg {
										width: 18px;
										height: 18px;
									}
								}

								.status-info {
									.status-name {
										font-size: 14px;
									}

									.status-desc {
										font-size: 11px;
									}
								}
							}
						}
					}
				}
			}

			.mobile-actions {
				padding: 16px;

				.el-button {
					padding: 10px 16px;
					font-size: 13px;
				}
			}
		}
	}
	  	}
</style>
